import * as ActionTypes from "constants/ActionTypes";

export const dashJsLoadComplete = () => ({
  type: ActionTypes.DASH_JS_LOAD_COMPLETE,
});

export const initialLoadComplete = () => ({
  type: ActionTypes.INITIAL_LOAD_COMPLETE,
});

export const verseThreeLoadComplete = () => ({
  type: ActionTypes.VERSE_THREE_LOAD_COMPLETE,
});
